<template>
    <div class="portfolio_edit_textarea mt10">
        <div class="filter_row mb20">
            <div class="filter_content language_filter">
                <span class="filter_title mr10">언어</span>
                <el-select v-model="language" class="select faq_select mr5"
                           :disabled="termsData.hasOwnProperty('c_idx')"
                           @change="parentChange('language', language)">
                    <el-option :value="''" :label="'선택'"></el-option>
                    <el-option v-for="(data, value, index) in languageList" :key="`termsLanguage${value}`"
                               :value="Number(data.c_idx)" :label="data.c_lang_ko"></el-option>
                </el-select>
            </div>
        </div>
        <quill-editor
            ref="contentEditor"
            class="h300"
            v-model="content"
            :options="editorOption"
        />
        <div class="input_error">{{ validation.firstError('content') }}</div>
    </div>
</template>

<script>

import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import quillEditorMixins from "@/mixins/quillEditorMixins";
import boardValidator from "@/mixins/validators/boardValidator";
import {appLanguage} from "@/service/languageService"

export default {
    name: "TermsWriteDefaultLayout",
    mixins: [alertMixins, boardValidator, quillEditorMixins],
    components: {},
    inject: {
        termsWriteSetData: {
            default: () => {
            }
        },
    },
    provide() {
        return {}
    },
    props: {
        termsData: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            language: '',
            languageList: appLanguage,
        }
    },
    created() {
    },
    mounted() {
        if (this.hasData()) {
            this.initSetData();
        }
        EventBus.$on('TermsWriteDefaultLayoutValidator', this.checkValidator);
    },
    beforeDestroy() {
        EventBus.$off('TermsWriteDefaultLayoutValidator')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initSetData() {
            this.content = this.termsData.c_config;
            this.parentChange('content', this.content);
            this.content = util.htmlDecode(this.content);
            this.parentChange('content', this.content);
            this.language = this.termsData.c_language;
            this.parentChange('language', this.language);
        },

        hasData() {
            return !util.isEmpty(this.termsData);
        },

        checkValidator(dataArr) {
            this.$validate(dataArr)
        },

        parentChange(key, value) {
            if(key === 'content'){
                this.content = this.replaceN(value);
                value = this.content
            }
            this.termsWriteSetData(key, value)
        },

    },
    watch: {
        'content': {
            deep: true,
            handler: function (val, oldVal) {
                this.parentChange('content', this.content)
            },
        },
        'termsData': {
            deep: true,
            handler: function (val, oldVal) {
                this.initSetData()
            },
        }
    },
}
</script>

<style scoped>

</style>
